import { useDispatch, useSelector } from "react-redux";
import { Sparkle } from "@phosphor-icons/react";
import { patchMiscMetadata } from "src/store/slices/profileMemorySlice";

const MemoryIntroBanner = () => {
  const dispatch = useDispatch();
  const threads = useSelector((state) => state.threads.threads);
  const hasChatHistory = Object.values(threads).some((arr) => arr.length > 0);
  const miscMetadataStatus = useSelector((state) => state.profileMemory.miscMetadataStatus);
  const isMemoryBannerShown = useSelector((state) => state.profileMemory.miscMetadata.isMemoryBannerShown);

  if (miscMetadataStatus !== "success" || isMemoryBannerShown) return null;

  const handleDismiss = () => {
    dispatch(patchMiscMetadata({ memory_information: { is_memory_banner_shown: true } }));
  };

  return (
    <div
      className="rounded-xl border border-[#E8D5F5] p-3 flex flex-col gap-3"
      style={{
        background: "linear-gradient(135deg, #FBF1F4 0%, #F8F0F8 50%, #F5EFF9 100%)",
      }}
    >
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-full bg-white shadow-md flex items-center justify-center shrink-0">
          <Sparkle size={16} weight="fill" className="text-[#1B2B48]" />
        </div>
        <div className="flex flex-col gap-1">
          <p className="text-[14px] font-semibold text-[#1B2B48]">Memory is new</p>
          <p className="text-[13px] text-[#6B7280] leading-[1.5]">
            {hasChatHistory
              ? "Inhouse now remembers context across all your conversations. Here's what we've learned about you so far."
              : "Inhouse will remember context as you chat. Your memory will build up here over time."}
          </p>
          <button
            onClick={handleDismiss}
            className="self-start text-[13px] font-medium text-white bg-[#1B2B48] mt-2 px-3 py-1.5 rounded-full cursor-pointer hover:bg-[#0d1524] transition-colors"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default MemoryIntroBanner;
